<template>
    <div>
        <div class="relative px-4 lg:px-6">
            <div class="absolute left-8 top-0 w-px h-full bg-slate-300 lg:left-16"></div>

            <template v-for="(match, matchIndex) in data.match_groups[props.matchGroupIndex].matches" :key="match.id">
                <automation-rule-form-match-item
                    :matchGroupIndex="matchGroupIndex"
                    :matchIndex="matchIndex"
                    v-model="data.match_groups[props.matchGroupIndex].matches[matchIndex]"
                />
            </template>

            <div class="flex items-center gap-4">
                <vx-box class="relative p-3 inline-flex space-x-2">
                    <vx-button
                        @click="addMatch(props.matchGroupIndex)"
                        type="button"
                        size="lg"
                        color="primary"
                        data-test="add-match-item"
                    >
                        {{
                            props.matchGroupIndex === 0 && !data.match_groups[props.matchGroupIndex].matches?.length
                                ? 'Add filter condition'
                                : 'And'
                        }}
                        <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </vx-button>
                    <vx-button
                        v-if="
                            props.isLast &&
                            !(props.matchGroupIndex === 0 && !data.match_groups[props.matchGroupIndex].matches?.length)
                        "
                        @click="addMatchGroup"
                        type="button"
                        size="lg"
                        color="info"
                        data-test="add-match-group"
                    >
                        Or <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </vx-button>
                </vx-box>
                <div v-if="displayFirstError(validate.matches)" class="text-xs text-rose-800">
                    {{ displayFirstError(validate.matches) }}
                </div>
            </div>
        </div>

        <div v-if="!props.isLast" class="relative flex p-8">
            <div
                class="absolute left-0 top-1/2 -translate-y-1/2 w-full h-px border-solid border-y border-x-0 border-t-slate-300 border-b-white"
            ></div>
            <div
                class="relative inline-block border border-solid border-slate-300 rounded-full overflow-hidden"
                style="filter: drop-shadow(0px 1px 0px #ffffff)"
            >
                <div
                    class="bg-amber-50 rounded-full overflow-hidden border-t border-solid border-white border-b-0 border-x-0 text-base font-extrabold py-2 px-6"
                >
                    Or
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { VxButton, VxBox } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { useAutomationRule } from './useAutomationRule';
import AutomationRuleFormMatchItem from './AutomationRuleFormMatchItem.vue';
import useVuelidate from '@vuelidate/core';
import { computed } from 'vue';
import { helpers, maxLength } from '@vuelidate/validators';
import { displayFirstError } from '~/utils/validation';

const props = defineProps({
    matchGroupIndex: {
        type: Number,
        required: true,
    },
    isLast: {
        type: Boolean,
        required: false,
    },
});

const { addMatchGroup, addMatch, data } = useAutomationRule();

const validate = useVuelidate(
    {
        matches: {
            maxLength: helpers.withMessage('An automation filter group can only contain 25 filters', maxLength(25)),
        },
    },
    computed(() => data.value.match_groups[props.matchGroupIndex])
);
</script>
